import React from "react";
import { FaCalendarAlt, FaArrowRight } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const EventsWeCaterSection = () => {
  const { title, items, note, ctaText } =
    SITE_CONTENT.pages.homePage.eventsWeCater;

  const scrollToBooking = (e) => {
    e.preventDefault();
    const el = document.getElementById("booking-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="bg-[#051109] text-white py-24 lg:py-32 relative overflow-hidden" id="events-we-cater">
      {/* Background Ambience */}
      <div className="absolute top-1/3 left-1/3 w-[550px] h-[550px] bg-[#006B54]/15 rounded-full blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-[#E8A040]/30 bg-[#E8A040]/10 text-[#E8A040] text-xs font-bold tracking-[0.25em] uppercase mb-4 shadow">
            Celebrations We Bring To Life
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif text-[#f8f4ee] mb-4">
            {title}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-transparent via-[#E8A040] to-transparent mx-auto" />
        </div>

        {/* 8 Events Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {items.map((eventItem, idx) => (
            <div
              key={idx}
              className="p-6 rounded-2xl bg-[#091f11]/80 backdrop-blur-sm border border-[#1b3f27] hover:border-[#E8A040] hover:bg-[#0d2a17] transition-all duration-300 flex items-start gap-3.5 group shadow-sm hover:-translate-y-1"
            >
              <div className="p-2.5 rounded-xl bg-[#132f1c] text-[#E8A040] group-hover:scale-110 transition-transform shrink-0">
                <FaCalendarAlt className="w-4 h-4" />
              </div>
              <div>
                <h3 className="font-medium text-base text-[#f5eedf] group-hover:text-[#F5C070] transition-colors leading-snug">
                  {eventItem}
                </h3>
                <span className="text-xs text-[#22c55e] mt-1 inline-block">
                  Custom Menu Ready
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Note & Direct Form CTA */}
        <div className="max-w-3xl mx-auto text-center p-8 rounded-3xl bg-[#0b2414] border border-[#235032] shadow-2xl">
          <p className="text-[#d0ded5] text-base sm:text-lg font-light leading-relaxed mb-6 italic">
            "{note}"
          </p>

          <a
            href="#booking-section"
            onClick={scrollToBooking}
            className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] text-[#0a1a0f] text-xs font-bold tracking-[0.15em] uppercase rounded-full shadow-[0_0_30px_rgba(232,160,64,0.3)] hover:scale-105 transition-all duration-300 group"
          >
            <span>{ctaText}</span>
            <FaArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
          </a>
        </div>

      </div>
    </section>
  );
};

export default EventsWeCaterSection;
